export const DemandasActionTypes = {
  API_RESPONSE_SUCCESS: '@@demandas/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@demandas/API_RESPONSE_ERROR',

  GET_DEMANDA: '@@demandas/GET_DEMANDA',
  LIST_DEMANDAS: '@@demandas/LIST_DEMANDAS',
  ADD_DEMANDA: '@@demandas/ADD_DEMANDA',
  UPDATE_DEMANDA: '@@demandas/UPDATE_DEMANDA',
  DELETE_DEMANDA: '@@demandas/DELETE_DEMANDA',

  RESET: '@@demandas/RESET'
}
